<template>
    <div>
        <button class="btn btn-lg btn-light notificationsBtn allBoxShadows" id="notificationsBtn">
            <i class="fad fa-bells faIcons"></i>
            <span class="badge badge-danger badge-pill" id="notificationsBadge"> {{ notificationsCount }} </span>
        </button>
        <div id="c-menu--slide-right" class="c-menu c-menu--slide-right">
            <div class="w-100">
                <div class="heading bg-light sticky-top pb-3">
                    <button class="c-menu__close allBoxShadow">
                        <i class="fa fa-times faTimesIcons d-block"></i>
                    </button>
                    <div class="d-flex flex-column text-right">
                        <span> اعلانات </span>
                        <small class="form-text text-muted ltr" style="margin-top: -2px;">
                            <span> {{ formatDate(lastUpdate) }} </span> <b> :بروزرسانی </b>
                        </small>
                    </div>
                </div>
                <div id="notifications-body">

                </div>
            </div>
        </div>
        <div id="c-mask1"></div>
    </div>
</template>

<script>
    import Menu from '@/assets/js/menu';
    import { mapState } from '@/assets/js/mapState';

    export default {
        name: "Notifications",
        props: ["lastUpdate", "notificationsCount"],
        mounted() {
            mapState.slideRight = new Menu({
                wrapper: '#o-wrapper',
                type: 'slide-right',
                menuOpenerClass: '.notificationsBtn',
                maskId: '#c-mask1'
            });
            let slideRightBtn = document.getElementById("notificationsBtn");
            slideRightBtn.addEventListener('click', function (e) {
                e.preventDefault();
                mapState.slideRight.open();
            });
        },
        methods : {
            formatDate(date) {
                let utcDate = new Date(date);
                let localDate = new persianDate(utcDate.getTime() + (utcDate.getTimezoneOffset() * 60000))
                        .format("L HH:mm");
                return localDate;
            }
        }
    }
</script>

<style>
    #notifications-body {
        padding: 0 !important;
        z-index: 4554545454 !important;
        font-size: 13px;
    }
</style>

<style lang="scss" scoped>
    @import "@/assets/css/tokens";

    .faIcons {
        width: auto;
        height: 1.1em;
        color: $text-secondary;
        transform: translate(0, 0);
    }

    .faTimesIcons {
        transform: translate(3px, 3.3px);
        font-size: 24px;
        width: auto;
        height: 1.5em;
    }

    #c-menu--slide-right {
        background-color: $bg-card;
    }

    .c-menu--slide-right .c-menu__close {
        border-radius: 6px;
        margin-left: 10px;
        display: inline-block;
        padding: 0 10px;
        width: 30px;
        height: 30px;
        line-height: 90px;
        z-index: 3453453453;
    }

    #notificationsBadge {
        position: absolute;
        top: 7px;
        right: 5px;
        font-size: 12px;
        font-weight: 700;
        color: #fff;
        box-shadow: 0 2px 6px rgba($accent-blue, 0.35);
    }

    #notificationsBtn {
        position: absolute;
        width: 55px;
        height: 55px;
        right: 10px;
        bottom: 10px;
        z-index: 2;
        padding: 9px 6px 7px;
        font-size: 32px;
    }

    #c-menu--slide-right::-webkit-scrollbar {
        width: 10px;
    }
    #c-menu--slide-right::-webkit-scrollbar-track {
        background-color: $bg-page;
    }
    #c-menu--slide-right::-webkit-scrollbar-thumb {
        background-color: $text-muted;
        border-radius: 6px;
    }
</style>
